import { Observable } from 'rxjs';

import { Diff } from '../../../common/model/publish-changes/diff.model';
import { TextDiffData } from '../../../common/model/publish-changes/text-diff-data.model';

export abstract class TextDiffWrapperContext {
  readonly abstract textDiff$: Observable<Diff<TextDiffData> | null>;
  readonly abstract currentBranch$: Observable<string | null>;
}
